import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import VendorHeader from "../component/VendorHeader";
import VendorFooter from "../component/VendorFooter";
import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import Sidebar from "../component/Sidebar";
import { NotificationManager } from "react-notifications";

const ContactForms = () => {
    const { user } = useAuth();
    const { langJson } = useLanguage();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [contactForms, setContactForms] = useState([]);

    const detailsBasePath = user?.role === "vendor" ? "/contact-forms" : "/admin/contact-forms";

    const getStatusTagClass = status => {
        switch (status?.toLowerCase()) {
            case "delivered":
                return "fs-tag--success";
            case "processing":
                return "fs-tag--warning";
            case "new":
                return "fs-tag--critical";
            case "cancelled":
                return "fs-tag--info";
            default:
                return "fs-tag--info";
        }
    };

    const fetchContactForms = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}stores/contact-forms`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${user?.authorisation?.token}`,
                },
            });

            const responseData = await response.json();
            if (response.ok && responseData?.res) {
                const list = Array.isArray(responseData?.data)
                    ? responseData.data
                    : responseData?.data?.data || [];
                setContactForms(list);
            } else {
                NotificationManager.warning(responseData?.msg || "Failed to fetch contact forms");
            }
        } catch (error) {
            NotificationManager.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchContactForms();
    }, []);

    return (
        <div>
            <div className="dashHeader">
                <VendorHeader />
            </div>
            <div className="adminDash">
                <Sidebar />
                <div className="rightSide rightTop">
                    <h2>{langJson?.contactforms ?? "Contact Forms"}</h2>

                    <div className="prdtTable">
                        <table>
                            <thead>
                                <tr>
                                    <th>{langJson?.date ?? "Date"}</th>
                                    <th>{langJson?.name ?? "Name"}</th>
                                    <th>{langJson?.email ?? "Email"}</th>
                                    <th>{langJson?.phone ?? "Phone"}</th>
                                    <th>{langJson?.status ?? "Status"}</th>
                                    <th>{langJson?.action ?? "Action"}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!loading && contactForms.length === 0 && (
                                    <tr>
                                        <td colSpan="6">No contact forms found</td>
                                    </tr>
                                )}

                                {loading && (
                                    <tr>
                                        <td colSpan="6">Loading...</td>
                                    </tr>
                                )}

                                {!loading &&
                                    contactForms.map(item => (
                                        <tr key={item?.id}>
                                            <td>{item?.created_at_human || item?.created_at || "-"}</td>
                                            <td>{item?.name || "-"}</td>
                                            <td>{item?.email || "-"}</td>
                                            <td>{item?.phone || "-"}</td>
                                            <td>
                                                <span className={`fs-tag ${getStatusTagClass(item?.status || "new")}`}>
                                                    {item?.status || "new"}
                                                </span>
                                            </td>
                                            <td className="actionHolder">
                                                <div className="actionDiv">
                                                    <button onClick={() => navigate(`${detailsBasePath}/${item?.id}`)}>
                                                        {langJson?.view ?? "View"}
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <VendorFooter />
        </div>
    );
};

export default ContactForms;
